import SchedulerFilters from "@/entities/scheduler/additionalFiltersInterfaces/SchedulerFilters";

const schedulerViewFiltersTemplate: SchedulerFilters = {
  countries: [],
  states: [],
  cities: [],
  criterias: [],
  projectNames: [],
  projectStatuses: [],
  users: [],
};

export default schedulerViewFiltersTemplate;
